import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from 'components/__new/common/Table';
import DateFormat from 'utils/dateFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Filter from 'components/__new/common/Filter';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { archiveEmployee } from 'store/entities/employees/action';
import iconSearch from "assets/images/icons/icon-search.svg";
import { getAllGroupEmployees } from 'store/entities/groups/action';
import useUrlQueryParams from 'hooks/useUrlQueryParams';
import processParams from 'utils/processParams';
import DownloadAsCSV from "components/__new/common/DownloadAsCSV";
import DynamicHeadTag from 'components/__new/common/DynamicHeadTag';
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import { TableContent } from 'components/__new/common/TableContent';
import DialogBox from 'utils/dialogBox';

const ViewGroupDetails = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { id } = useParams()
    const location = useLocation();
    const { urlQueryParams } = useUrlQueryParams();
    const employeesDownloadRef = useRef()

    const [query, setQuery] = useState('');
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 9999,
    });
    const { getAllGroupEmployeesLoading: loading, allGroups: { policies: groups }, allGroupEmployees } = useSelector(state => state.entities.groups)
    const [selected, setSelected] = useState([]);

    const actual = groups?.find(group => group._id === id)
    const returnToGroups = () => history.push('/groups')
    const allEmployeeIDs = allGroupEmployees?.employees?.map(item => item._id)

    const filteredEmployees = allGroupEmployees?.employees?.filter(employee => {
        if (query === "") {
            return true
        } else {
            return employee.fullName?.toLowerCase().includes(query.toLowerCase())
        }
    })

const BulkActionHandler = ({count, onCancel}) => {
	return (
		<div className='flex items-center space-x-4'>
			<button className="flex items-center text-red-500">
				<IconTrash style={{height: "1.375rem", marginRight: "0.5rem"}} /> Delete
			</button>
			<div style={{backgroundColor: "#e5e7eb", height: "1.375rem", width: '2px', marginRight: "0.5rem"}} />
			<div className="flex items-center space-x-4">
				<p className="mb-0 text-[#6c757d] text-sm">{count} selected</p>
				<IconsTimes onClick={onCancel} className="svg-fill-red cursor-pointer" />
			</div>
		</div>
	)
}

    const toggleSingleEmployee = (id) => {
        const alreadyExists = selected?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = selected?.filter(item => item !== id)
            setSelected(filtered)
        } else {
            setSelected([...selected, id])
        }
    }

    const toggleEntireList = () => {
        if (selected.length !== allEmployeeIDs?.length) {
            setSelected(allEmployeeIDs)
        } else {
            setSelected([])
        }
    }
    
    const removeEmployee = async (id) => {
        const result = await DialogBox({
			title: "Delete Employee 😯",
			content: "Are you sure you want to delete this employee? This action cannot be undone",
			buttonYes: "Delete",
            buttonYesClass: "text-white bg-[#EB0000]",
			buttonNo: "No, thanks",
		});
		if (result) {
            dispatch(archiveEmployee(id)).then(() => getEmployees());
        }
    }

    const getEmployees = () => {
        let params = { ...listParams };

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 9999, "limit");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "search", "string", "", "fullName");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");

        setListParams(params);
        dispatch(getAllGroupEmployees(actual?._id, params));
    }

    useEffect(() => {
        if (!actual) {
            returnToGroups()
        } else {
            getEmployees()
        }
        // eslint-disable-next-line
    }, [location])

    return (
        <div>
            <DynamicHeadTag headerText="Company | Group Details" headerDescription="" />
            <div className="lg:flex">
                <div className="w-full lg:w-3/4">
                    <div onClick={() => history.push('/groups')} className="page-title flex items-center cursor-pointer w-max">
                        <FontAwesomeIcon icon="angle-left" className='mr-4' />
                        <span className="capitalize">{actual?.name}</span>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4">
                <div className="mt-6 flex flex-wrap justify-between px-3">
                    {selected?.length > 1 ?<BulkActionHandler count={selected?.length} onCancel={() => setSelected([])} /> :
                    <div className="flex items-center">
                        <input onChange={() => toggleEntireList()}
                            checked={allGroupEmployees?.employees?.length > 0 && selected?.length === allEmployeeIDs?.length}
                            type="checkbox" className="w-5 h-5 mr-3.5 form-checkbox float-left" />
                        <div className="form-group-icon h-10 rounded-md bg-gray-100 border-none">
                            <label htmlFor="search">
                                <img src={iconSearch} alt="Search" className="form-group-icon-attach h-4" />
                            </label>
                            <input
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                placeholder="Search by full name"
                                className="h-full form-input-icon bg-gray-100"
                            />
                        </div>
                    </div>}
                    <div className="flex flex-wrap space-x-3 sm:space-x-6">
                        <div>
                            <Filter filters={[
                                {
                                    title: "Status",
                                    name: "status",
                                    dataType: "radio",
                                    options: [
                                        {
                                            display: "All",
                                            payload: "",
                                        },
                                        {
                                            display: "Enrolled",
                                            payload: "active",
                                        },
                                        {
                                            display: "Pending",
                                            payload: "pending",
                                        },
                                    ],
                                },
                            ]} />
                        </div>

                        <DownloadAsCSV
                            ref={employeesDownloadRef}
                            tooltip={`Download Employees for ${actual?.name}`}
                            filename="All Employees.csv"
                            columns={[
                                { label: "Full Name", key: "fullName" },
                                { label: "Email", key: "email" },
                                { label: "Job Title", key: "jobTitle" },
                            ]}
                            click={() => employeesDownloadRef.current?.downloadData()}
                            loading={false}
                            response={allGroupEmployees?.employees}
                        />
                    </div>
                </div>
                <div className='mt-8'>
                    <Table>
                        <Table.Head>
                            <th></th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email Address</th>
                            <th>Date Added</th>
                            <th>Job Title</th>
                            <th>Status</th>
                            <th></th>
                        </Table.Head>
                        <Table.Body>
                            
                            <TableContent
                                colspan={8}
                                data={allGroupEmployees?.employees}
                                loading={loading}
                                total={allGroupEmployees?.employees?.length}
                                dataContent={allGroupEmployees?.employees?.length}
                                loadingText="Loading employees"
                                emptyText="No employees found"
                            />
                            
                            {loading === false && filteredEmployees?.map((employee) => {
                                const firstName = employee?.fullName.split(" ")[0]
                                const lastName = employee?.fullName.split(" ")[1]
                                const empId = employee._id
                                const isDisabled = employee?.disabled
                                const isActive = employee.status === 'active'
                                const isPending = employee.status === 'pending'

                                return (
                                    <tr key={empId}>
                                        <td style={{width: "1px"}}>
                                            <input 
                                                value={empId} 
                                                type="checkbox" 
                                                disabled={loading} 
                                                onChange={() => toggleSingleEmployee(empId)}
                                                className="w-5 h-5 mr-2 form-checkbox float-left" 
                                                checked={allGroupEmployees?.employees?.length > 0 && selected?.includes(empId)}
                                            />
                                        </td>
                                        <td>
                                            <div className='capitalize'>
                                                {firstName}
                                            </div>
                                        </td>
                                        <td>
                                            <div className='capitalize'>
                                                {lastName}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {employee.email}
                                            </div>
                                        </td>
                                        <td>
                                            {DateFormat(employee.createdAt)}
                                        </td>
                                        <td>
                                            {employee.jobTitle}
                                        </td>
                                        <td>
                                            <div style={{
                                                color: isDisabled ? '#ff3e30' : isActive ? '#34a853' : isPending ? '#f49d1b' : "",
                                                backgroundColor: isDisabled ? '#EB00001A' : isActive ? '#34A8531A' : isPending ? '#F49D1B1A' : ""
                                            }} className="px-3 py-1 rounded-md flex items-center justify-center capitalize">
                                                {isDisabled ? "Disabled" : employee.status}
                                            </div>
                                        </td>
                                        <td>
                                            <button onClick={() => removeEmployee(empId)} className="outline-none text-[#EB0000] underline">Remove</button>
                                        </td>
                                    </tr>
                                )
                            }
                            )}

                        </Table.Body>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export default ViewGroupDetails